<template>
  <div class="container-fluid">
    <h1 class="text-center mt-4 p-2 fw-normal mb-3">Mis pedidos</h1>
    <div class="px-4" id="order-info">
      <span class="fw-semibold" v-if="orders.length==1"> {{ orders.length }} pedido</span>
      <span class="fw-semibold" v-else> {{ orders.length }} pedidos</span>
      <span id="total-price">Total: {{ totalPrice.toFixed(2) }}€</span>
    </div>
    <div id="orders" class="row justify-content-center mt-4 mb-5" style="overflow-y: auto;" v-if="orders.length > 0">
      <div class="col-11 shadow rounded-4 py-2 mb-3" v-for="order in orders" :key="order.id" @click="selectOrder(order)">
        <div class="align-items-center">
          <div id="platos" class="row">
            <div class="col-12">
              <div v-for="plate in order.plates"  :key="plate.id"  class="m-2 rounded-3 d-inline-block" :style="{ width: '50px', height: '50px' }">
                <img v-if="plate.photo" :src="plate.photo" class="w-100 h-100" :alt="plate.name" style="object-fit: contain;" />
                <div v-else  v-html="noPhoto" class="w-100 h-100 d-flex align-items-center justify-content-center" style="object-fit: contain;"></div>
              </div>            
            </div>
          </div>
          <div class="row p-1 w-100 m-0 text-center">
            <div class="col-3 d-flex flex-column align-items-center justify-content-center">
              <b class="fs-2" style="color:#0A2533">{{ order.number }}</b>
              <span>{{ formatTime(order.date) }}h</span>
            </div>
            <div class="col-6 d-flex align-items-end justify-content-center">
              <b v-if="order.state === 'PENDIENTE'" class="text-danger">Pendiente</b>
              <b v-else-if="order.state === 'EN ESPERA'" class="text-warning">En espera</b>
              <b v-else-if="order.state === 'EN CURSO'" class="text-warning">En curso</b>
              <b v-else-if="order.state === 'EN CAMINO'" class="text-info">En camino</b>
              <b v-else-if="order.state === 'LISTO'" class="text-info">Listo</b>
              <b v-else-if="order.state === 'ENTREGADO'" class="text-success">Entregado</b>
              <b v-else-if="order.state === 'CANCELADO' || order.state === 'CANCELADO POR CLIENTE'" class="text-grey">Cancelado</b>
              <b v-else-if="order.state === 'PAGADO'" class="text-primary">Pagado</b>
            </div>
            <div class="col-3 d-flex align-items-end justify-content-center fw-bold">
              <b>{{ order.price.toFixed(2) }}€</b>
            </div>
          </div>
        </div>
      </div>
      <div v-if="(timeLeftDelivery||timeLeftTakeAway) && orders[0].state != 'ENTREGADO' && orders[0].state != 'EN ESPERA'" class="px-5 mt-3" style="font-size: 1.1rem;">
        <p v-if="timeLeftDelivery>0" class="text-success">¡Ves preparando la mesa! <i class="fa-solid fa-utensils me-2" style="font-size: 1.4rem;"></i> El restaurante estima que recibirás tu pedido en <span class="fw-bold">{{ timeLeftDelivery }} minuto<span v-if="timeLeftDelivery>1">s</span>.</span></p>
        <p v-else-if="timeLeftTakeAway>0 && orders[0].state != 'LISTO'" class="text-success">¡Corre a por tu pedido! <i class="fa-solid fa-utensils me-2" style="font-size: 1.4rem;"></i> El restaurante estima que tendrá listo tu pedido en <span class="fw-bold">{{ timeLeftTakeAway }} minuto<span v-if="timeLeftTakeAway>1">s</span></span> para recoger.</p>
        <p v-else-if="orders[0].state == 'LISTO'" class="text-success">Tu pedido ya esta esperándote en el restaurante <i class="fa-solid fa-utensils me-2" style="font-size: 1.4rem;"></i></p>
        <p v-else class="text-danger">Parece que tu pedido se esta demorando un poco <i class="fa-solid fa-face-frown me-2" style="font-size: 1.4rem;"></i> Contacta al restaurante si necesitas más info.</p>
      </div>
      <div class="text-center mb-3" v-if="userAllowedToCancel">
          <button v-if="orders.length > 0 && ((orders[0].deliveries && orders[0].deliveries[0]) || (orders[0].take_aways && orders[0].take_aways[0])) && (orders[0].state === 'PENDIENTE' || orders[0].state === 'EN ESPERA')" @click="orderUpdateByUser('CANCELADO POR CLIENTE')" class="btn btn-danger mr-5">Cancelar Pedido</button>
          <button v-if="orders.length > 0 && ((orders[0].deliveries && orders[0].deliveries[0]) || (orders[0].take_aways && orders[0].take_aways[0])) && orders[0].state === 'EN ESPERA'" @click="orderUpdateByUser('EN CURSO')" class="btn btn-success">Confirmar Pedido</button>
      </div>
      <div v-if="(timeLeftDelivery||timeLeftTakeAway) && orders[0].state === 'EN ESPERA'" class="text-center" style="font-size: 1.1rem;">
        <p v-if="timeLeftDelivery>0" class="text-success">El restaurante estima que recibirás tu pedido en <span class="fw-bold">{{ timeLeftDelivery }} minuto<span v-if="timeLeftDelivery>1">s</span>.</span><br/><br/><span v-if="userAllowedToCancel">En caso de estar de acuerdo, confirma el pedido para que el restaurante comience a prepararlo.</span></p>
        <p v-else-if="timeLeftTakeAway>0 && orders[0].state != 'LISTO'" class="text-success">El restaurante estima que tendrá listo tu pedido en <span class="fw-bold">{{ timeLeftTakeAway }} minuto<span v-if="timeLeftTakeAway>1">s</span></span> para recoger. <br/><br/><span v-if="userAllowedToCancel">En caso de estar de acuerdo, confirma el pedido para que el restaurante comience a prepararlo.</span></p>
      </div>
    </div>
    <div v-else class="h-75 d-flex align-items-center justify-content-center">
      <div class="row">
        <div class="mx-auto" v-html="anyone_order"></div>
        <h2 class="text-center mt-3">Aun no has hecho ningun pedido</h2>
      </div>
    </div>
    <MyOrderDetails
      :visible="modalDisplay"
      :order="order"
      @close="modalDisplay = false"
    ></MyOrderDetails>
    <SpinnerComponent id="spinner"></SpinnerComponent>
  </div>
</template>

<script>
  import MyOrderDetails from '@/components/MyOrderDetails.vue'
  import axios from 'axios';
  import { mapState } from 'vuex';
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import noPhoto from '@/assets/no_plate.svg?raw';

  import anyone_order from '@/assets/anyone_order.svg?raw';

  export default {
    data() {
      return {
        orders: [],
        modalDisplay: false,
        order: null,
        first_charge: true,
        noPhoto,
        anyone_order
      };
    },
    components: {
      MyOrderDetails,
      SpinnerComponent
    },
    computed: {
      ...mapState(['token']),
      ...mapState(['userAllowedToCancel']),
      totalPrice() {
        let total = 0

        this.orders.forEach(order=>{
          total += order.price
        })

        return total
      },
      timeLeftDelivery(){
        try{
          console.log("HOLAAA")
          console.log(this.orders[0].deliveries[0].run_time)
          if(this.orders[0].deliveries[0].final_data){
            const finalDate = new Date(this.orders[0].deliveries[0].final_data); // Fecha objetivo
            const currentDate = new Date(); // Fecha actual
            const timeDifference = (finalDate - currentDate) / 60000; // Diferencia en milisegundos a minutos
            return Math.floor(timeDifference);
          } else if (this.orders[0].deliveries[0].run_time){
            return this.orders[0].deliveries[0].run_time
          }
          else { 
            return false
          }
        }
        catch{
          return false
        }
      },
      timeLeftTakeAway(){
        try{
          if(this.orders[0].take_aways[0].final_data){
            const finalDate = new Date(this.orders[0].take_aways[0].final_data); // Fecha objetivo
            const currentDate = new Date(); // Fecha actual
            const timeDifference = (finalDate - currentDate) / 60000; // Diferencia en milisegundos a minutos
            return Math.floor(timeDifference);
          } else if (this.orders[0].take_aways[0].run_time){
            return this.orders[0].take_aways[0].run_time
          } else { 
            return false
          }
        }
        catch{
          return false
        }
      }
    },
    methods: {
      formatTime(dateTime) {
          const date = new Date(dateTime);
          console.log(date)
          const hours = String(date.getHours()).padStart(2, '0'); 
          let minutes = String(date.getMinutes()).padStart(2, '0');
          return `${hours}:${minutes}`;
      },
      selectOrder(order) {
        this.order = order;
        this.modalDisplay = true;
      },
      async fetchGetOrders() {
        const token = this.token; // Suponiendo que tienes el token almacenado en Vuex
        const url = process.env.VUE_APP_API_URL+'/v1/api/app/MyOrders';
        try {
          const response = await axios.get(url, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          let orders = response.data.orders
          let mode = response.data.mode

          let i = 1
          orders.forEach(order=>{
            try{
                order.number = i
                let min_state = null

                let plates_structure = []
                
                order.shopping_carts.forEach(shopping_cart=>{
                    let plate_structure = {}
                    plate_structure.id = shopping_cart.id
                    plate_structure.plate_id = shopping_cart.plate.id
                    plate_structure.name = shopping_cart.plate.name
                    plate_structure.description = shopping_cart.plate.description
                    plate_structure.category=shopping_cart.plate.category
                    plate_structure.photo = shopping_cart.plate.photo
                    plate_structure.price = shopping_cart.unit_price
                    plate_structure.amount = shopping_cart.amount
                    plate_structure.comment = shopping_cart.comment
                    plate_structure.steps = shopping_cart.plate.steps

                    let i = 0
                    plate_structure.steps.forEach(step=>{
                      if(shopping_cart.steps_selected.length > i){
                        step.plate_selected = shopping_cart.steps_selected[i].plate
                      }
                      i++
                    })
                    
                    if (mode && plate_structure.category && !mode.excluded_categories.some(cat => cat.id === plate_structure.category.id)){
                        plate_structure.price *= (100 - mode.discount) / 100
                        plate_structure.price = Math.round(plate_structure.price * 100) / 100;
                    }

                    if (mode && !plate_structure.category){
                      if(plate_structure.plate_id == 'd368dc34-ca2a-4976-8834-9e5dd6e28e25'){
                        plate_structure.price = mode.adult_price
                      }else if(plate_structure.plate_id == 'ad9e80c6-fd8d-4d42-8227-89155ab7c210'){
                        plate_structure.price = mode.children_price
                      }
                    }

                    // Ordenos los estados de cada plato de mayor a menor
                    shopping_cart.state_orders = shopping_cart.state_orders.sort((a, b) => {
                        return new Date(b.created_at)- new Date(a.created_at);
                    });

                    console.log(shopping_cart.state_orders)
                    plate_structure.state = shopping_cart.state_orders[0].state
                    console.log("nuevo state: "+ plate_structure.state)
                    console.log(min_state)
                    if (min_state == null || min_state[0] > plate_structure.state.sort){
                        min_state = [plate_structure.state.sort, plate_structure.state.name]
                    }
                    console.log(min_state)

                    plate_structure.state = plate_structure.state.name

                    plates_structure.push(plate_structure)
                })

                order.plates = plates_structure

                order.state = min_state[1]
                i++
              }catch{
                console.log("error en un plato")
              }
          })

          this.orders = orders
          console.log(this.orders, "AQUIII")

          if(this.first_charge){
            document.getElementById("spinner").classList.add("d-none")
            this.first_charge=false
          }

          if (this.order != null){
            let order_selected = this.orders.find(item => item.id === this.order.id);
            if(order_selected){
              this.order = order_selected
            }
            else{
              this.modalDisplay = false
              this.order = null
            }
          }
        } catch (error) {
          // Maneja el error
          this.orders = []
          console.error('Error fetching my orders:', error);
          document.getElementById("spinner").classList.add("d-none")
        }
      },
      async orderUpdateByUser(newState) {
        try {
          const url = process.env.VUE_APP_API_URL + '/v1/api/app/ChangeStateOrder_Delivery_TakeAway';
          if(this.orders[0].state === 'PENDIENTE' && newState === 'CANCELADO POR CLIENTE' || this.orders[0].state === 'EN ESPERA' && newState === 'EN CURSO'){
              await axios.put(url, null, {
                params: { state_name: newState, order_id: this.orders[0].id },
                headers: { 'Authorization': `Bearer ${this.token}` }
              });
            this.fetchGetOrders();
          }
        } catch (error) {
          console.error('Error al cancelar el pedido:', error);
        }
      },
      startPolling() {
        this.fetchGetOrders();
        this.pollingInterval = setInterval(this.fetchGetOrders, 15000); // Cada 15 segundos
      },
      stopPolling() {
        clearInterval(this.pollingInterval);
      },
    },
    created() {
    this.startPolling();
    },
    beforeUnmount() {
      this.stopPolling();
    }
  };
</script>

<style>

  #platos {
    display: flex;
    overflow-x: auto; /* Cambiado de scroll a auto para mejor comportamiento */
    white-space: nowrap;
    position: relative;
    mask-image: linear-gradient(to right, transparent, black 0%, black 80%, transparent);
  }

  #platos img,
  #platos .no-photo svg {
    object-fit: contain;
    display: block;
  }

  #platos::-webkit-scrollbar {
    height: 2px;
  }

  #platos::-webkit-scrollbar-thumb {
    background-color: rgba(var(--primary-color-rgb), 0.68);
    border-radius: 10px;
  }

  #order-info #total-price {
    font-size: 18px;
    font-weight: bold;
  }
</style>